import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { LocalNotifications } from '@capacitor/local-notifications';

@Injectable({
  providedIn: 'root'
})
export class LocalNotificationService {
  constructor() { }

  async sendLocalNotification(id: number, title: string, body: string, icon: string = '', badge: number = 0) {
    await LocalNotifications.schedule({
        notifications: [
            {
                id: id,
                title: title,
                body: body,
                channelId: "default" // important!
            }
        ]
    });
  }

  async clearLocalNotification() {
    // Cancel all scheduled notifications
    // await LocalNotifications.removeAllListeners();

    // Clear all delivered notifications from the tray
    await LocalNotifications.removeAllDeliveredNotifications();
  }
}